import {createRouter, createWebHistory} from 'vue-router'
import store from '@/store/store'
import { product } from '@product/product.js'

import { wsProgramBroadcast } from '@/store/wsBroadcast.js'

const HIDE_NAV_BAR_FLOW_ROUTES = new Set(product.hideNavBarRouteNames)

// БАЗОВЫЕ РОУТЫ - НАЧАЛО
//registration/auth
import LogIn from '@/views/auth/LogIn.vue'
import Register from '@/views/auth/Register.vue'
import Welcome from '@/views/auth/Welcome.vue'


import Page404 from '@/views/system/Page404.vue'
import BaseLayout from '@/layouts/BaseLayout.vue'
import {subscriptionStatuses} from '@/configs/subscriptionStatuses.js'
// БАЗОВЫЕ РОУТЫ - КОНЕЦ

const routes = [
  {
    path: '/desktop',
    name: 'Desktop',
    component: () => import('@/desktop/layouts/BaseDesktopLayout.vue'),
    meta: {
      layout: 'HomeLayout',
      onboardingIsAllowed: true,
      isDesktop: true,
      isPublic: true,
      allowAuth: true
    },
    children: [
      {
        path: '',
        redirect: { name: 'DesktopBroadcasts' }
      },
      {
        path: 'auth',
        name: 'DesktopAuth',
        meta: {
          layout: 'EmptyLayout',
          disableRedirect: true
        },
        component: () => import('@/desktop/views/auth/DesktopAuth.vue')
      },
      {
        path: 'broadcasts',
        name: 'DesktopBroadcastsMain',
        meta: {
          navigationTab: 'broadcasts'
        },
        children: [
          {
            path: '',
            name: 'DesktopBroadcasts',
            component: () => import('@/desktop/views/broadcasts/DesktopBroadcasts.vue')
          },
          {
            path: 'study/:userCourseId',
            name: 'DesktopBroadcast',
            props: true,
            component: () => import('@/desktop/views/broadcasts/DesktopBroadcast.vue')
          }
        ]
      },
      {
        path: 'courses',
        name: 'DesktopCourses',
        meta: {
          navigationTab: 'courses'
        },
        component: () => import('@/desktop/views/courses/DesktopCourses.vue')
      },
      {
        path: 'my-courses',
        name: 'DesktopMyCoursesMain',
        meta: {
          navigationTab: 'my-courses'
        },
        children: [
          {
            path: '',
            name: 'DesktopMyCourses',
            component: () => import('@/desktop/views/study/DesktopStudy.vue')
          },
          {
            path: 'study/:userCourseId',
            name: 'DesktopStudyLesson',
            props: true,
            component: () => import('@/desktop/views/study/DesktopStudyLesson.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/payment-form',
    name: 'PaymentForm',
    meta: {
      onboardingIsAllowed: true,
      // requiresNotActiveSubscription: true,
      // requiresNotPendingSubscription: true,
      isPublic: true,
      allowAuth: true
    },
    component: () => import('@/views/auth/PagePaymentForm/PagePaymentForm.vue')
  },
  {
    path: '/payment-form-promo',
    name: 'PaymentFormPromo',
    meta: {
      onboardingIsAllowed: true,
      isPublic: true,
      allowAuth: true
    },
    component: () => import('@/views/auth/PagePaymentForm/PagePaymentFormPromo.vue')
  },
  {
    path: '/',
    component: BaseLayout,
    meta: {
      layout: 'HomeLayout',
      navigationTab: 'home',
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: product.components.home,
        meta: {
          historyDisableBack: true,
          historyClear: true
        }
      },
      {
        path: 'event/:eventId',
        name: 'HomeEvent',
        component: () => import('@/views/HomeView/HomeEvent.vue'),
        meta: {
          layout: 'EmptyHomeLayout'
        }
      },
      {
        path: 'collections',
        name: 'CollectionsPage',
        component: () => import('@/views/collections/CollectionsPage.vue'),
        meta: {
          layout: 'EmptyHomeLayout',
          checkAccessTiers: true,
          section: "collections"
        }
      },
      {
        path: 'collections/:collectionId',
        meta: {
          layout: 'EmptyHomeLayout',
          checkAccessTiers: true,
          section: "collections"
        },
        children: [
          {
            path: '',
            name: 'Collection',
            component: () => import('@/views/collections/Collection.vue'),
            props: true
          },
          {
            path: 'profile/:userId',
            name: 'CollectionUserProfile',
            component: () => import('@/views/profile/AnotherUserProfile.vue'),
            props: true,
            meta: {
              returnName: 'Collection',
              layout: 'HomeLayout',
              chatName: 'CollectionUserChat'
            }
          },
          {
            path: 'profile/:userId/chat/:sentUID?',
            name: 'CollectionUserChat',
            component: () => import('@/views/chat/UserChat.vue'),
            props: true,
            meta: { returnName: 'CollectionUserProfile', layout: 'EmptyLayout' }
          },
          {
            path: 'lesson',
            name: 'CollectionLesson',
            component: () => import('@/views/collections/CollectionLesson.vue'),
            props: true
          }
        ]
      },
      {
        path: 'events',
        children: [
          {
            path: '',
            name: 'Events',
            component: () => import('@/views/events/Events.vue'),
            meta: {
              layout: 'EmptyHomeLayout'
            }
          },
          {
            path: ':date',
            name: 'EventsByDate',
            component: () => import('@/views/events/Events.vue'),
            props: true,
            meta: {
              layout: 'EmptyHomeLayout'
            }
          }
        ]
      },
      {
        path: 'subscription',
        children: [
          {
            path: 'tariff-selection',
            name: 'SubscriptionTariffSelection',
            component: () => import('@/views/subscriptions/SubscriptionTariffSelection.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              onboardingIsAllowed: true
              // requiresNotActiveSubscription: true,
              // requiresNotPendingSubscription: true,
            }
          },
          {
            path: 'payment',
            name: 'SubscriptionPayment',
            component: () => import('@/views/subscriptions/SubscriptionPayment.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              onboardingIsAllowed: true
              // requiresNotActiveSubscription: true,
              // requiresNotPendingSubscription: true,
            }
          },
          {
            path: 'edit-email',
            name: 'SubscriptionEditEmail',
            component: () => import('@/views/subscriptions/SubscriptionEditEmail.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              onboardingIsAllowed: true
              // requiresNotActiveSubscription: true,
              // requiresNotPendingSubscription: true,
            }
          },
          {
            path: 'edit-telegram',
            name: 'SubscriptionEditTelegram',
            component: () => import('@/views/subscriptions/SubscriptionEditTelegram.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              onboardingIsAllowed: true
              // requiresNotActiveSubscription: true,
              // requiresNotPendingSubscription: true,
            }
          },
          //
          {
            path: 'edit-full-name',
            name: 'SubscriptionEditFullName',
            component: () => import('@/views/subscriptions/SubscriptionEditFullName.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              onboardingIsAllowed: true
              // requiresNotActiveSubscription: true,
              // requiresNotPendingSubscription: true,
            }
          },
          //
          {
            path: 'pending',
            name: 'SubscriptionPending',
            component: () => import('@/views/subscriptions/SubscriptionPending.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              onboardingIsAllowed: true
              // requiresNotActiveSubscription: true,
              // requiresPendingSubscription: true,
            }
          },
          {
            path: 'control',
            name: 'SubscriptionControl',
            component: () => import('@/views/subscriptions/SubscriptionControl.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              requiresActiveSubscription: true
            }
          },
          {
            path: 'control/cancel',
            name: 'SubscriptionControlCancel',
            component: () => import('@/views/subscriptions/SubscriptionControlCancel.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              requiresActiveSubscription: true
            }
          },
          {
            path: '/subscription-offer',
            name: 'SubscriptionSubscriptionOffer',
            component: product.components.subscriptionOffer,
            meta: { returnName: 'SubscriptionPayment', onboardingIsAllowed: true }
          },
          {
            path: '/privacy-policy',
            name: 'SubscriptionPrivacyPolicy',
            component: product.components.privacyPolicy,
            meta: { returnName: 'SubscriptionPayment', onboardingIsAllowed: true }
          },
          {
            path: '/user-agreement',
            name: 'SubscriptionUserAgreement',
            component: product.components.userAgreement,
            meta: { returnName: 'SubscriptionPayment', onboardingIsAllowed: true }
          },
          {
            path: '/personal-data-processing',
            name: 'SubscriptionPersonalDataProcessing',
            component: product.components.personalDataProcessing,
            meta: { returnName: 'SubscriptionPayment', onboardingIsAllowed: true }
          }
        ]
      },
      { path: 'event/:eventId', name: 'Event', component: () => import('@/views/HomeView/EventPage.vue'), props: true },
      {
        path: 'study',
        children: [
          {
            path: 'broadcasts',
            children: [
              {
                path: '',
                name: 'MarketplaceBroadcasts',
                component: product.components.marketplaceBroadcasts,
                children: product.broadcastRoutes,
              },
              {
                path: ':courseId/about',
                name: 'MarketplaceBroadcastLanding',
                component: product.components.marketplaceBroadcastLanding,
                props: true
              },
              {
                path: ':courseId/about/profile/:userId',
                name: 'BroadcastsAboutUserProfile',
                component: () => import('@/views/profile/AnotherUserProfile.vue'),
                props: true,
                meta: { returnName: 'MarketplaceBroadcastLanding', layout: 'HomeLayout' }
              },
              {
                path: ':userCourseId/view',
                name: 'StudyBroadcast',
                component: () => import('@/views/study/StudyBroadcast.vue'),
                props: true
              }
            ]
          },
          {
            path: 'courses',
            children: [
              {
                path: '',
                name: 'MarketplaceCourses',
                component: () => import('@/views/study/MarketplaceCourses.vue')
              },
              {
                path: ':courseId/paid',
                name: 'CoursePaid',
                component: () => import('@/views/study/CoursePaid.vue'),
                meta: { layout: 'EmptyLayout' },
                props: true
              },
              {
                path: ':courseId/about',
                name: 'MarketplaceCourseLanding',
                component: () => import('@/views/study/MarketplaceCourseLanding.vue'),
                props: true
              },
              {
                path: ':courseId/about/profile/:userId',
                name: 'CourseAboutUserProfile',
                component: () => import('@/views/profile/AnotherUserProfile.vue'),
                props: true,
                meta: { returnName: 'MarketplaceCourseLanding', layout: 'HomeLayout' }
              },
              {
                path: 'subscription',
                name: 'BuySubscription',
                component: () => import('@/views/subscriptions/BuySubscription.vue'),
                props: true
              }
            ]
          },
          {
            path: 'my-courses',
            children: [
              {
                path: '',
                name: 'StudyCourses',
                component: () => import('@/views/study/Study.vue')
              },
              {
                path: ':userCourseId',
                children: [
                  {
                    path: '',
                    name: 'StudyCourse',
                    component: () => import('@/views/study/StudyCourse.vue'),
                    meta: { returnName: 'BrowsingUserView' },
                    props: true
                  },
                  {
                    path: '',
                    name: 'CourseReview',
                    component: () => import('@/views/study/reviews/StudyCourseReview.vue'),
                    props: true,
                    meta: { layout: 'EmptyLayout' }
                  },
                  {
                    path: 'module',
                    children: [
                      {
                        path: ':moduleId',
                        children: [
                          {
                            path: '',
                            name: 'StudyModule',
                            component: () => import('@/views/study/StudyModule.vue'),
                            props: true
                          },
                          {
                            path: 'lesson',
                            children: [
                              {
                                path: ':lessonId',
                                children: [
                                  {
                                    path: '',
                                    name: 'StudyModuleLesson',
                                    component: () => import('@/views/study/StudyLesson.vue'),
                                    props: true
                                  },
                                  {
                                    path: 'test/:testId',
                                    name: 'StudyModuleTest',
                                    component: () => import('@/views/study/StudyTest.vue'),
                                    props: true
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            path: 'review',
                            name: 'StudyModuleReview',
                            component: () => import('@/views/study/reviews/StudyModuleReview.vue'),
                            props: true
                          },
                          {
                            path: 'questions',
                            name: 'StudyModuleQuestions',
                            component: () => import('@/views/study/StudyCourseQuestions.vue'),
                            props: true
                          }
                        ]
                      }
                    ]
                  },
                  {
                    path: 'lesson',
                    children: [
                      {
                        path: ':lessonId',
                        children: [
                          {
                            path: '',
                            name: 'StudyCourseLesson',
                            component: () => import('@/views/study/StudyLesson.vue'),
                            props: true
                          },
                          {
                            path: 'test/:testId',
                            name: 'StudyCourseTest',
                            component: () => import('@/views/study/StudyTest.vue'),
                            props: true
                          }
                        ]
                      }
                    ]
                  },
                  {
                    path: 'review',
                    name: 'StudyCourseReview',
                    component: () => import('@/views/study/reviews/StudyCourseReview.vue'),
                    props: true
                  },
                  {
                    path: 'questions',
                    name: 'StudyCourseQuestions',
                    component: () => import('@/views/study/StudyCourseQuestions.vue'),
                    props: true
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'browsing/:userId?',
        meta: {
          // isEnoughFilledRequired: true,
          // isEnoughFilledRequiredData: {
          //   text: 'Чтобы получить доступ к нетворкингу и другим функциям приложения'
          // }
        },
        children: [
          {
            path: '',
            name: 'SocialBrowsing',
            component: () => import('@/views/social/SocialBrowsing.vue'),
            props: true
          },
          {
            path: 'view',
            name: 'BrowsingUserView',
            component: () => import('@/views/social/BrowsingUserSearch.vue'),
            meta: { returnName: 'SocialBrowsing', isPage: true }
          },
          {
            path: 'search/:filter?',
            name: 'BrowsingUserSearch',
            props: true,
            meta: { returnName: 'BrowsingUserView', defaultSearch: 'global_result' },
            component: () => import('@/views/social/UserSearch.vue')
          },
          {
            path: '/search/:userId/chat/:sentUID?',
            children: [
              {
                path: '',
                name: 'SearchUserChat',
                component: () => import('@/views/chat/UserChat.vue'),
                props: true,
                meta: { returnName: 'BrowsingUserSearch', layout: 'EmptyLayout' }
              }
            ]
          },
          {
            path: 'profile/:userId',
            name: 'BrowsingUserProfile',
            component: () => import('@/views/profile/AnotherUserProfile.vue'),
            props: true,
            meta: { returnName: 'BrowsingUserView', chatName: 'BrowsingUserChat' }
          },
          {
            path: 'chat/:sentUID?',
            children: [
              {
                path: '',
                name: 'BrowsingUserChat',
                component: () => import('@/views/chat/UserChat.vue'),
                props: true,
                meta: { returnName: 'SocialBrowsing', layout: 'EmptyLayout' }
              }
            ]
          }
        ]
      },
      {
        path: 'marketplace',
        name: 'MarketplaceRoute',
        children: [
          {
            path: 'products/:productId?',
            children: [
              {
                path: '',
                name: 'MarketplaceProducts',
                component: () => import('@/views/marketplace/MarketplaceProducts.vue'),
                props: true,
                meta: { chatName: 'MarketplaceProductUserChat', layout: 'EmptyHomeLayout' }
              },
              {
                path: 'user/:userId/chat/:sentUID?',
                name: 'MarketplaceProductUserChat',
                component: () => import('@/views/chat/UserChat.vue'),
                props: true,
                meta: { returnName: 'MarketplaceProducts', layout: 'EmptyLayout' }
              },
              {
                path: 'search',
                name: 'MarketplaceProductsSearch',
                props: true,
                component: () => import('@/views/marketplace/MarketplaceProductsSearch.vue'),
                meta: { layout: 'EmptyHomeLayout' }
              },
              {
                path: 'user/:userId/profile',
                name: 'MarketplaceProductsUserProfile',
                component: () => import('@/views/profile/AnotherUserProfile.vue'),
                props: true,
                meta: {
                  returnName: 'MarketplaceProducts',
                  chatName: 'MarketplaceProductsUserProfileChat'
                }
              },
              {
                path: 'user/:userId/chat/:sentUID?',
                name: 'MarketplaceProductsUserProfileChat',
                component: () => import('@/views/chat/UserChat.vue'),
                props: true,
                meta: { returnName: 'MarketplaceProductsUserProfile', layout: 'EmptyLayout' }
              }
            ]
          }
        ]
      },
      {
        path: 'my',
        children: [
          {
            path: 'profile',
            name: 'Profile',
            component: product.components.profile,
            meta: {
              navigationTab: 'profile'
            }
          },
          {
            path: 'profile/card',
            name: 'ProfileCard',
            component: product.components.profileCard,
          },
          {
            path: 'profile/support/chat/:userId',
            name: 'MyProfileSupportChat',
            component: () => import('@/views/chat/UserChat.vue'),
            props: true,
            meta: { returnName: 'Profile', layout: 'EmptyLayout' }
          },
          {
            path: 'profile/checklist',
            children: [
              {
                path: '',
                name: 'CheckList',
                component: () => import('@/views/profile/CheckList.vue'),
                meta: { layout: 'EmptyLayout' }
              },
              {
                path: 'profile',
                name: 'CheckListEditProfile',
                component: product.components.editProfile,
                meta: { returnName: 'CheckList', isCheckList: true }
              },
              {
                path: 'products',
                meta: {
                  isEnoughFilledRequired: true
                },
                children: [
                  {
                    path: '',
                    name: 'CheckListEditProducts',
                    component: () => import('@/views/profile/editProfile/EditProducts.vue'),
                    meta: { returnName: 'CheckList', isCheckList: true }
                  },
                  {
                    path: 'edit/create',
                    name: 'CheckListCreateProduct',
                    component: () => import('@/views/profile/editProfile/EditProduct.vue'),
                    meta: { isCreate: true, returnName: 'CheckListEditProducts', isCheckList: true }
                  },
                  {
                    path: 'edit/:productId',
                    name: 'CheckListEditProduct',
                    component: () => import('@/views/profile/editProfile/EditProduct.vue'),
                    props: true,
                    meta: { returnName: 'CheckListEditProducts', isCheckList: true }
                  }
                ]
              },
              {
                path: 'achievements',
                children: [
                  {
                    path: '',
                    name: 'CheckListEditAchievements',
                    component: () => import('@/views/profile/editProfile/EditAchievements.vue'),
                    meta: { returnName: 'CheckList', isCheckList: true }
                  },
                  {
                    path: 'edit/create',
                    name: 'CheckListCreateAchievement',
                    component: () => import('@/views/profile/editProfile/EditAchievement.vue'),
                    meta: {
                      isCreate: true,
                      returnName: 'CheckListEditAchievements',
                      isCheckList: true
                    }
                  },
                  {
                    path: 'edit/:achievementId',
                    name: 'CheckListEditAchievement',
                    component: () => import('@/views/profile/editProfile/EditAchievement.vue'),
                    props: true,
                    meta: { returnName: 'CheckListEditAchievements', isCheckList: true }
                  }
                ]
              },
              {
                path: 'education',
                children: [
                  {
                    path: '',
                    name: 'CheckListEditEducations',
                    component: () => import('@/views/profile/editProfile/EditEducations.vue'),
                    meta: { returnName: 'CheckList', isCheckList: true }
                  },
                  {
                    path: 'edit/create',
                    name: 'CheckListCreateEducation',
                    component: () => import('@/views/profile/editProfile/EditEducation.vue'),
                    meta: { isCreate: true, returnName: 'CheckList', isCheckList: true }
                  },
                  {
                    path: 'edit/:educationType/:educationId',
                    name: 'CheckListEditEducation',
                    component: () => import('@/views/profile/editProfile/EditEducation.vue'),
                    props: true,
                    meta: { returnName: 'CheckList', isCheckList: true }
                  }
                ]
              },
              {
                path: 'looking-for',
                name: 'CheckListEditLookingFor',
                component: product.components.editLookingFor,
                meta: { returnName: 'CheckList', isCheckList: true }
              },
              {
                path: 'personal-data',
                name: 'CheckListEditPersonalData',
                component: () => import('@/views/profile/editProfile/EditPersonalData.vue'),
                meta: { returnName: 'CheckList', isCheckList: true }
              },
              {
                path: 'description',
                name: 'CheckListEditDescription',
                component: () => import('@/views/profile/editProfile/EditDescription.vue'),
                meta: { returnName: 'CheckList', isCheckList: true }
              },
              {
                path: 'contacts',
                name: 'CheckListEditContacts',
                component: () => import('@/views/profile/editProfile/EditContacts.vue'),
                meta: { returnName: 'CheckList', isCheckList: true }
              },
              {
                path: 'professions',
                name: 'CheckListEditProfessions',
                component: () => import('@/views/profile/editProfile/EditProfessions.vue'),
                meta: { returnName: 'CheckList', isCheckList: true }
              },
              {
                path: 'niches',
                name: 'CheckListEditNiches',
                component: product.components.editNiches,
                meta: { returnName: 'CheckList', isCheckList: true }
              }
            ]
          },
          {
            path: 'profile/onboarding',
            name: 'Onboarding',
            component: product.components.onboarding,
            meta: { layout: 'EmptyLayout' }
          },
          {
            path: 'profile/onwards',
            name: 'Onwards',
            component: product.components.onwards,
            meta: { layout: 'EmptyLayout' }
          },
          {
            path: 'profile/edit',
            name: 'EditProfileView',
            children: [
              {
                path: '',
                name: 'EditProfile',
                component: product.components.editProfile,
              },
              {
                path: 'looking-for',
                name: 'EditLookingFor',
                component: product.components.editLookingFor,
              },
              {
                path: 'niches',
                name: 'EditNiches',
                component: product.components.editNiches,
              },
              { path: 'personal-data', name: 'EditPersonalData', component: () => import('@/views/profile/editProfile/EditPersonalData.vue') },
              { path: 'description', name: 'EditDescription', component: () => import('@/views/profile/editProfile/EditDescription.vue') },
              { path: 'contacts', name: 'EditContacts', component: () => import('@/views/profile/editProfile/EditContacts.vue') },
              { path: 'professions', name: 'EditProfessions', component: () => import('@/views/profile/editProfile/EditProfessions.vue') },
              ...product.profileEditRoutes,
              {
                path: 'achievements',
                children: [
                  { path: '', name: 'EditAchievements', component: () => import('@/views/profile/editProfile/EditAchievements.vue') },
                  {
                    path: 'edit/create',
                    name: 'CreateAchievement',
                    component: () => import('@/views/profile/editProfile/EditAchievement.vue'),
                    meta: { isCreate: true }
                  },
                  {
                    path: 'edit/:achievementId',
                    name: 'EditAchievement',
                    component: () => import('@/views/profile/editProfile/EditAchievement.vue'),
                    props: true
                  }
                ]
              },
              {
                path: 'education',
                children: [
                  {
                    path: '',
                    name: 'EditEducations',
                    component: () => import('@/views/profile/editProfile/EditEducations.vue')
                  },
                  {
                    path: 'edit/create',
                    name: 'CreateEducation',
                    component: () => import('@/views/profile/editProfile/EditEducation.vue'),
                    meta: { isCreate: true }
                  },
                  {
                    path: 'edit/:educationType/:educationId',
                    name: 'EditEducation',
                    component: () => import('@/views/profile/editProfile/EditEducation.vue'),
                    props: true
                  }
                ]
              },
              {
                path: 'products',
                children: [
                  { path: '', name: 'EditProducts', component: () => import('@/views/profile/editProfile/EditProducts.vue') },
                  {
                    path: 'edit/create',
                    name: 'CreateProduct',
                    component: () => import('@/views/profile/editProfile/EditProduct.vue'),
                    meta: { isCreate: true }
                  },
                  {
                    path: 'edit/:productId',
                    name: 'EditProduct',
                    component: () => import('@/views/profile/editProfile/EditProduct.vue'),
                    props: true
                  }
                ]
              }
            ]
          },
          ...product.myRoutes,
        ]
      },
      {
        path: 'user/:userId',
        children: [
          {
            path: 'profile',
            name: 'AnotherUsersProfile',
            component: () => import('@/views/profile/AnotherUserProfile.vue'),
            props: true,
            meta: { returnName: 'Home', chatName: 'AnotherUsersProfileChat' }
          },
          {
            path: 'chat/:sentUID?',
            name: 'AnotherUsersProfileChat',
            component: () => import('@/views/chat/UserChat.vue'),
            props: true,
            meta: { returnName: 'AnotherUsersProfile', layout: 'EmptyLayout' }
          }
        ]
      },
      {
        path: 'social',
        meta: { navigationTab: 'social' },
        children: [
          {
            path: 'browsing/:userId?',
            name: 'CardHolderSocialBrowsing',
            component: () => import('@/views/social/SocialBrowsing.vue'),
            props: true,
            meta: { returnName: 'CardHolder' }
          },
          {
            path: 'card-holder',
            meta: {
              // isEnoughFilledRequired: true,
              // isEnoughFilledRequiredData: {
              //   text: 'Чтобы получить доступ к нетворкингу и другим функциям приложения'
              // }
            },
            children: [
              {
                path: '',
                children: [
                  {
                    path: 'list/:tab?',
                    name: 'CardHolder',
                    component: () => import('@/views/social/CardHolder.vue'),
                    meta: {
                      historyDisableBack: true
                    }
                  }
                ]
              },
              {
                path: 'search/:filter?',
                name: 'CardHolderSearch',
                meta: { returnName: 'CardHolder', defaultSearch: 'contacts_result' },
                props: true,
                component: () => import('@/views/social/UserSearch.vue')
              },
              {
                path: 'search/user/:userId/profile',
                name: 'CardHolderSearchUserProfile',
                component: () => import('@/views/profile/AnotherUserProfile.vue'),
                props: true,
                meta: {
                  returnName: 'CardHolderSearch',
                  chatName: 'CardHolderSearchUserProfileChat'
                }
              },
              {
                path: 'search/user/:userId/chat/:sentUID?',
                name: 'CardHolderSearchUserProfileChat',
                component: () => import('@/views/chat/UserChat.vue'),
                props: true,
                meta: { returnName: 'CardHolderSearchUserProfile', layout: 'EmptyLayout' }
              },
              {
                path: 'user/:userId',
                children: [
                  {
                    path: 'profile',
                    name: 'CardHolderUserProfile',
                    component: () => import('@/views/profile/AnotherUserProfile.vue'),
                    props: true,
                    meta: { returnName: 'CardHolder', chatName: 'CardHolderUserChat' }
                  },
                  {
                    path: 'chat/:sentUID?',
                    name: 'CardHolderUserChat',
                    component: () => import('@/views/chat/UserChat.vue'),
                    props: true,
                    meta: { returnName: 'CardHolderUserProfile', layout: 'EmptyLayout' }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/chat',
        meta: { navigationTab: 'chat' },
        children: [
          {
            path: 'list/:tab?',
            name: 'ChatList',
            component: () => import('@/views/chat/ChatList.vue'),
            meta: {
              layout: 'EmptyHomeLayout',
              historyDisableBack: true,
              requiresActiveSubscription: product.chatRequiresActiveSubscription,
            }
          },
          {
            path: 'user/:userId/profile',
            name: 'CardHolderUserProfileChat',
            component: () => import('@/views/profile/AnotherUserProfile.vue'),
            props: true,
            meta: { returnName: 'UserChat', chatName: 'UserChat' }
          },
          {
            path: 'user/:userId/:sentUID?',
            children: [
              {
                path: '',
                name: 'UserChat',
                component: () => import('@/views/chat/UserChat.vue'),
                props: true,
                meta: { returnName: 'ChatList', layout: 'EmptyLayout' }
              }
            ]
          }
        ]
      },
      {
        path: 'faq',
        name: 'FaqPageMain',
        component: product.components.faq,
        meta: { layout: 'EmptyLayout' }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    meta: {
      requiresAuth: true,
      layout: 'EmptyLayout'
    },
    component: Page404
  },
  {
    path: '/',
    component: BaseLayout,
    meta: {
      requiresGuest: true,
      layout: 'EmptyLayout'
    },
    children: [
      {
        path: 'privacy-policy',
        name: 'PrivacyPolicy',
        component: product.components.privacyPolicy,
        meta: {onboardingIsAllowed: true},
      },
      {
        path: 'information-advertising-policy',
        name: 'InformationAdvertisingPolicy',
        component: product.components.informationAdvertisingPolicy,
        meta: {onboardingIsAllowed: true},
      },
      {
        path: 'user-agreement',
        name: 'UserAgreement',
        component: product.components.userAgreement,
        meta: {onboardingIsAllowed: true},
      },
      {
        path: 'personal-data-processing',
        name: 'PersonalDataProcessing',
        component: product.components.personalDataProcessing,
        meta: {onboardingIsAllowed: true},
      },
      //
      {
        path: 'welcome',
        name: 'Welcome',
        meta: {
          requiresGuest: true,
          layout: 'EmptyLayout'
        },
        component: Welcome
      },
      {
        path: 'login',
        name: 'LogIn',
        meta: {
          requiresGuest: true,
          layout: 'EmptyLayout'
        },
        component: LogIn
      },
      {
        path: 'register',
        name: 'Register',
        meta: {
          requiresGuest: true,
          layout: 'EmptyLayout'
        },
        component: Register
      }
      // {
      //   preview: 'preview',
      //   meta: {
      //     requiresGuest: true,
      //     layout: 'EmptyLayout',
      //   },
      //   children: [
      //     {
      //       path: '/event/:eventId',
      //       name: 'EventPreview',
      //       component: EventPreviewPage,
      //       props: true,
      //       meta: {layout: 'EmptyLayout'}
      //     },
      //     {
      //       path: '/user/:userId',
      //       name: 'AnotherUsersProfilePreview',
      //       component: AnotherUsersProfilePreviewPage,
      //       props: true,
      //       meta: {layout: 'EmptyLayout'}
      //     },
      //     {
      //       path: '/product/:productId',
      //       name: 'MarketplaceProductPreview',
      //       component: MarketplaceProductPreviewPage,
      //       props: true,
      //       meta: {layout: 'EmptyLayout'}
      //     },
      //   ],
      // },
    ]
  }
];

const history = createWebHistory()

const router = createRouter({
  history,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
});

window.backActions = []
let backActionUsed = false

router.beforeEach(async (to, from, next) => {
  const { isAuthorized, isRestoring, profile } = store.state.user
  const subscriptions = profile?.subscriptions || []
  const hasPaymentInPending = subscriptions.some(sub => sub.payments.some(({ status }) => status === 'pending'))

  const statusPriority = ['active', 'disabled', 'new']
  const allStatuses = subscriptions.map(s => s.status)
  const subscriptionStatus = statusPriority.find(p => allStatuses.includes(p)) || subscriptionStatuses.new

  const isTrainingProgramRoute = to.path.includes('trainings') && to.params.id
  const isHomeRoute = to.name === 'Home'

  if (isTrainingProgramRoute) {
    wsProgramBroadcast.startProgramBroadcast(to.params.id)
  } else if (!isHomeRoute && wsProgramBroadcast.isActive) {
    // Home сам поднимает WS для актуальной программы; иначе закрываем
    wsProgramBroadcast.stopProgramBroadcast()
  }

  if (window.event?.type === 'popstate' && isAuthorized && from.meta.historyDisableBack) {
    // console.log('stop')
    next(false)
    return
  }

  if (window.event?.type === 'popstate' && isAuthorized) {
    if (window.backActions.length && !backActionUsed) {
      // console.log('pop')
      next(false)
      backActionUsed = true
      setTimeout(() => backActionUsed = false, 0)
      window.backActions.pop()()
      return
    }
    // console.log('con')
  }

  // policies handle
  if (to.name) {
    const name = to.name.replace('Subscription', '') //TODO это очень плохое решение
    const policy = product.resolvePolicies(store.state.app?.appData?.policy ?? {})

    switch (name) {
      case 'InformationAdvertisingPolicy':
      case 'PersonalDataProcessing':
      case 'PrivacyPolicy':
      case 'SubscriptionOffer':
      case 'SubscriptionOfferPromo':
      case 'UserAgreement': {
        const url = policy[name]
        if (url) {
          window.open(url, '_blank').focus()
          next(false)
          return
        }
        break
      }
    }
  }

  if (store.state.app.hideNavBar && !HIDE_NAV_BAR_FLOW_ROUTES.has(to.name)) {
    store.commit('app/setHideNavBar', false)
  }

  if (isAuthorized) {
    if (to.query.redirect_action && to.query.redirect_action === 'payment_result' && to.query.payment_id) {
      store.dispatch('app/setMessageComponent', {
        messageComponent: 'PaymentResult',
        messageComponentData: { query: to.query },
      })
      next({
        name: to.name,
        replace: true
      })
      return
    }

    if (!profile.onboarding_finished && to.name !== 'Onboarding' && !to.meta.onboardingIsAllowed) {
      next({
        name: 'Onboarding',
        query: to.query
      })
      return
    }
    if (profile.onboarding_finished && localStorage.getItem('onboardingContinuation') && to.name !== 'Onwards') {
      next({
        name: 'Onwards',
      })
      return
    }

    if (to.meta.isEnoughFilledRequired && !store.getters["user/profileProgress"].isEnoughFilled) {
      if (from.name === 'Welcome') {
        next({
          name: 'Home'
        })
        return
      }

      store.dispatch('app/setMessageComponent', {
        messageComponent: 'EnoughFilledRequired',
        messageComponentData: to.meta.isEnoughFilledRequiredData,
      })
      return
    }

    if (to.meta.checkAccessTiers) {
      const { profile_access_tier_order } = store.getters["user/profile"]
      const currentAccessTier = store.getters["user/directories"]["access_tiers"].find(({ order }) => order === profile_access_tier_order)
      const currentForbid = currentAccessTier.forbids.find(({ section }) => section === to.meta.section)

      if (!currentForbid) {
        next()
        return
      }

      const { denied = [] } = currentForbid

      const deniedObject = denied.reduce((acc, deny) => {
        const key = Object.keys(deny).find(key => !!deny[key])

        acc[key] = {
          banner: deny.banner,
          value: true
        }
        return acc
      }, {})

      if (!deniedObject.enter) {
        next()
        return
      } else if (to.params && to.params.collectionId) {
        if (!deniedObject.full_content && !deniedObject.enter) {
          next()
          return
        }
      }

      store.dispatch('app/setMessageComponent', {
        messageComponent: 'EnoughFilledRequired',
        messageComponentData: deniedObject.full_content?.banner || deniedObject.enter?.banner,
      })
      return
    }

    if (to.meta.requiresPendingSubscription && subscriptionStatus !== subscriptionStatuses.pending) {
      next({
        name: 'SubscriptionControl',
      })
      return
    }
    if (to.meta.requiresNotPendingSubscription && subscriptionStatus === subscriptionStatuses.pending) {
      next({
        name: 'SubscriptionPending',
      })
      return
    }
    if (to.meta.requiresNotActiveSubscription && subscriptionStatus === subscriptionStatuses.active) {
      next({
        name: 'SubscriptionControl',
      })
      return
    }

    if (to.meta.requiresActiveSubscription && subscriptionStatus !== subscriptionStatuses.active) {
      if (subscriptionStatus === 'disabled' || hasPaymentInPending) {
        next()
      } else {
        next({
          name: 'SubscriptionTariffSelection',
        })
      }
      return
    }
  }

  if (to.meta.allowAuth) {
    if (isAuthorized) {
      // skip
    } else {
      if (isRestoring) {
        const query = {}
        if (to.fullPath !== '/') {
          query.returnTo = encodeURIComponent(to.fullPath)
        }
        next({
          name: 'Welcome',
          query,
        })
      } else {
        next()
      }
      return
    }
  }

  if (to.meta.requiresGuest) {
    if (isAuthorized) {
      next('/')
    }
  }

  if (to.meta.requiresAuth) {
    if (isAuthorized) {
      // const after = sessionStorage.getItem('previewAfterOnboarding')
      // if (after) {
      //   sessionStorage.removeItem('previewAfterOnboarding')
      //   next(JSON.parse(after))
      //   return
      // }
    } else {
      const query = {}
      if (to.fullPath !== '/') {
        query.returnTo = encodeURIComponent(to.fullPath)
      }
      if(to.meta.isDesktop) {
        next({
          name: 'DesktopAuth',
          query,
        })
      } else {
        next({
          name: 'Welcome',
          query,
        })
      }
      return
    }
  }

  if (window.event?.type === 'popstate') {
    if (from.meta.historyDisableBack) {
      next(false)
      return
    }
  }

  next()
})

export {router}
